var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('div',[_c('v-list-item',{on:{"click":function($event){return _vm.open()}}},[_vm._v("Open")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }